import axiosInstance from "@/config/axiosInstance";

export const getAdminRegistrations = async (params = {}) => {
  const response = await axiosInstance.get("/api/admin/registrations", {
    params,
    withCredentials: true,
  });

  return response.data;
};

export const approveAdminRegistration = async (id) => {
  const response = await axiosInstance.patch(
    `/api/admin/registrations/${id}/approve`,
    {},
    {
      withCredentials: true,
    }
  );

  return response.data;
};

export const inactivateAdminRegistration = async (id) => {
  const response = await axiosInstance.patch(
    `/api/admin/registrations/${id}/inactivate`,
    {},
    {
      withCredentials: true,
    }
  );

  return response.data;
};

export const rejectAdminRegistration = async ({ id, reason }) => {
  const response = await axiosInstance.patch(
    `/api/admin/registrations/${id}/reject`,
    { reason },
    {
      withCredentials: true,
    }
  );

  return response.data;
};

export const editAdminRegistration = async ({ id, payload }) => {
  const response = await axiosInstance.patch(`/api/admin/registrations/${id}`, payload, {
    withCredentials: true,
  });

  return response.data;
};
